export default class CertificateAdjuster {
  checkQuotes(str) {
    let result = 0; let
      i = 0;
    for (i; i < str.length; i++) {
      if (str[i] === '"') { result++; }
    }
    return !(result % 2);
  }

  extract(from, what) {
    let certName = '';

    const begin = from.indexOf(what);

    if (begin >= 0) {
      let end = from.indexOf(', ', begin);
      while (end > 0) {
        if (this.checkQuotes(from.substr(begin, end - begin))) { break; }
        end = from.indexOf(', ', end + 1);
      }
      certName = (end < 0) ? from.substr(begin) : from.substr(begin, end - begin);
    }

    return certName;
  }

  extractWithOutWhatName(from, what) {
    let certName = '';

    const begin = from.indexOf(what);
    if (begin >= 0) {
      let end = from.indexOf(', ', begin);
      while (end > 0) {
        if (this.checkQuotes(from.substr(begin, end - begin))) { break; }
        end = from.indexOf(', ', end + 1);
      }
      certName = (end < 0) ? from.substr(begin) : from.substr(begin, end - begin);
      certName = certName.substr(what.length);
    }

    return certName;
  }

  Print2Digit(digit) {
    return (digit < 10) ? `0${digit}` : digit;
  }

  GetCertDate(paramDate) {
    const certDate = new Date(paramDate);
    return `${this.Print2Digit(certDate.getUTCDate())}.${this.Print2Digit(certDate.getUTCMonth() + 1)}.${certDate.getFullYear()} ${
      this.Print2Digit(certDate.getUTCHours())}:${this.Print2Digit(certDate.getUTCMinutes())}:${this.Print2Digit(certDate.getUTCSeconds())}`;
  }

  GetCertName(certSubjectName) {
    return this.extract(certSubjectName, 'CN=');
  }

  GetIssuer(certIssuerName) {
    return this.extract(certIssuerName, 'CN=');
  }

  GetCertInfoString(certSubjectName, certFromDate) {
    return `${this.extract(certSubjectName, 'CN=')}; Выдан: ${this.GetCertDate(certFromDate)}`;
  }
}
